module.exports = __webpack_public_path__ + "img/css-modules.10391496.png";